module.exports = __webpack_public_path__ + "static/media/Collab.690d3baa.svg";